// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"525":"02a6cd52","879":"455ff5df"}[chunkId] + ".chunk.js";
};